<template>
	<page>
		<listTemplate page-title="List" :pid="$cid.video" :page-size="limit" type="video"
			@article-click="itemClick"></listTemplate>
		<CmsVideoPlayer :src="videoSrc" :visible.sync="visible" :poster="poster" />
		<CmsFramePlayer :src="liveSrc" :visible.sync="liveVisible" />
	</page>
</template>
<script>
	import listTemplate from "~/components/entemplate/listTemplate.vue";
	import CmsVideoPlayer from "~/components/cms/CmsVideoPlayer.vue";
	import CmsFramePlayer from "~/components/cms/CmsFramePlayer.vue";

	export default {
		components: {
			listTemplate,
			CmsVideoPlayer,
			CmsFramePlayer
		},
		data() {
			return {
				videoSrc: '',
				visible: false,
				poster: '',
				liveSrc: '',
				liveVisible: false,
				tabIndex: 0,
				defaultTabId: '666',
				limit:9
			}
		},
		mounted() {
			if(document.getElementsByClassName('zui-page')[0].getAttribute("class").includes("mobileClass")){
				this.limit = 8
			}
		},
		methods: {
			itemClick(data) {
				if (this.tabIndex === 0) {
					this.videoSrc = data.ext1;
					this.poster = data.cover;
					this.$nextTick(() => {
						this.visible = true;
					})
				} else {
					this.liveSrc = data.ext1;
					this.$nextTick(() => {
						this.liveVisible = true;
					});
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/english/TravelInfo/Videos.vue